
(function (w, d) {
  'use strict';

  var DL = w.DJIDataLayer;
  if (!DL) return;

  var C = {
    service:    { component_id: 'footer_customer_service', placement: 'footer_top_service' },
    contact:    { component_id: 'footer_contact',          placement: 'footer_bottom' },
    newsletter: { component_id: 'footer_newsletter',       placement: 'footer_subscription' }
  };

  var SEL = {
    footer:    'footer, .footer, [class*="dji-ftf"], [class*="dji-fb"], #shopify-section-footer',
    chatLink:  'a.dji-ftf__link[href*="/chat"], a[href*="/pages/chat"], a[href*="zoho"], a[href*="salesiq"]',
    phoneLink: 'a[href^="tel:"]',
    mailLink:  'a[href^="mailto:"]'
  };

  
  function entryLabel(el) {
    var t = (el && el.innerText ? el.innerText : '').trim().toLowerCase();
    if (!t) return 'chat';
    return t.replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '').slice(0, 40) || 'chat';
  }

  function now() { return Date.now ? Date.now() : new Date().getTime(); }

  function base(cfg, extra) {
    var out = {
      page_type: DL.ctx.page_type,
      component_id: cfg.component_id,
      placement: cfg.placement
    };
    for (var k in (extra || {})) out[k] = extra[k];
    return out;
  }

  function fireServiceOpen(label) {
    DL.push('customer_service_open', base(C.service, {
      entry_label: label,
      service_type: 'live_chat'
    }));
  }

  
  var pending = null;   // { label: string, until: number }

  (function hookOpen() {
    var native = w.open;
    if (typeof native !== 'function' || native.__djiHooked) return;
    var patched = function (url, name) {
      var win = native.apply(this, arguments);
      try {
        if (pending && now() <= pending.until) {
          var isChat = /chat|zoho|salesiq/i.test(String(url || '') + '|' + String(name || ''));
          if (isChat && win) fireServiceOpen(pending.label);
          pending = null;
        }
      } catch (e) {  }
      return win;
    };
    patched.__djiHooked = true;
    try { w.open = patched; } catch (e) {  }
  })();

  
  d.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    if (!t.closest(SEL.footer)) return;

    var chat = t.closest(SEL.chatLink);
    if (chat) {
      if (!DL.isInteractive(chat)) return;
      var label = entryLabel(chat);
      pending = { label: label, until: now() + 1500 };
      
      DL.afterTick(function () {
        if (!pending) return;               
        if (!DL.clickWillSucceed(evt, chat)) { pending = null; return; }
        pending = null;
        fireServiceOpen(label);
      });
      return;
    }

    
    var tel = t.closest(SEL.phoneLink);
    var mail = tel ? null : t.closest(SEL.mailLink);
    if (!tel && !mail) return;
    var link = tel || mail;
    if (!DL.isInteractive(link)) return;
    DL.afterTick(function () {
      DL.push('contact_action_click', base(C.contact, {
        contact_type: tel ? 'phone' : 'email'
        
      }));
    });
  }, true);

  /* ================================================================ */
  /* Footer Newsletter · newsletter_subscribe                          */
  /* ================================================================ */

  
  
  var NL_KEY = 'dji_nl_footer';

  function emitNewsletter() {
    
    var rec = null;
    try {
      rec = JSON.parse(w.sessionStorage.getItem(NL_KEY) || 'null');
      if (rec) w.sessionStorage.removeItem(NL_KEY);
    } catch (e) {}

    if (!d.querySelector('[data-dji-newsletter-success]')) return;
    if (!rec || rec.src !== 'footer') return;

    
    if (Date.now() - (rec.at || 0) > 120000) return;
    if (!DL.onceSession('footer_newsletter|' + rec.at)) return;

    DL.push('newsletter_subscribe', base(C.newsletter, {
      form_id: 'footer_newsletter',
      subscription_status: 'success',
      consent_checked: rec.consent === null ? undefined : !!rec.consent
      
    }));
  }

  emitNewsletter();

  DL.log('footer tracking ready');
})(window, document);
